import type { RouteLocationNormalized } from 'vue-router'
import { storeEmailDownloadToken } from '@/models/EmailDownload/Link'

export default function emailDownloadGuard(to: RouteLocationNormalized) {
	if (to.hash) {
		storeEmailDownloadToken(to.hash)
		return { path: to.path, query: to.query, hash: '', replace: true }
	}
}
